import {
  useApolloClient,
  useLazyQuery,
  useMutation,
  useQuery,
  useSubscription,
} from "@apollo/client";
import {
  MUTATE_CLOSE_SERVICE_CONNECTION,
  MUTATE_USER_VIEWING_PAGE,
  QUERY_CONNECTED_SERVICES,
  QUERY_LAST_N_LOGS,
  QUERY_LOGS_BY_DATE_RANGE,
  QUERY_SERVER_TIME,
  QUERY_USERS_VIEWING_PAGES,
  RESET_AKS_DASHBOARD,
  RESET_PROCESSED_WIN_TAX_VARS,
  SUBSCRIBE_HEARTBEAT,
  SUBSCRIBE_NEW_CONNECTED_SERVICE_UPDATE,
  SUBSCRIBE_NEW_LOG_UPDATE,
  SUBSCRIBE_NEW_SERVER_TIME_UPDATE,
  SUBSCRIBE_NEW_USER_VIEWING_PAGE_UPDATE,
  SUBSCRIBE_RESET_FRONTEND,
} from "../queries/adminQueries";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  addLog,
  resetUsersViewingPages,
  setConnectedServices,
  setConnectedServiceUpdate,
  setLogs,
  setServerTime,
  setUsersViewingPages,
  setUserViewingPageUpdate,
  setWsConnectedState,
} from "../../../state/adminReducer";
import { resetApp } from "../../../state";
import toast from "react-hot-toast";

export function MutateResetProcessedWinTAXVars() {
  const [resetProcessedWinTAXVars] = useMutation(RESET_PROCESSED_WIN_TAX_VARS);
  return resetProcessedWinTAXVars;
}

export function MutateResetAKSDashboard() {
  const [resetAKSDashboard] = useMutation(RESET_AKS_DASHBOARD);
  return resetAKSDashboard;
}

export function MutateUserViewingPage() {
  const [mutateUserViewingPage] = useMutation(MUTATE_USER_VIEWING_PAGE);
  return mutateUserViewingPage;
}

export function MutateCloseServiceConnection() {
  const [mutateCloseServiceConnection] = useMutation(
    MUTATE_CLOSE_SERVICE_CONNECTION,
  );
  return mutateCloseServiceConnection;
}

export function QueryUsersViewingPages() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetUsersViewingPages());
  }, [dispatch]);
  const { data, loading, error } = useQuery(QUERY_USERS_VIEWING_PAGES);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setUsersViewingPages(data.getUsersViewingPages));
    }
  }, [dispatch, data, loading, error]);
}

export function QueryLogs() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_LAST_N_LOGS, {
    variables: { n: 500 },
  });

  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setLogs(data.getLastNLogs));
    }
  }, [dispatch, data, loading, error]);
}

export function QueryLastNLogs() {
  const dispatch = useDispatch();
  const [queryLastNLogs, { data, loading, error }] =
    useLazyQuery(QUERY_LAST_N_LOGS);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setLogs(data.getLastNLogs));
    }
  }, [dispatch, data, loading, error]);

  return (n: number) => {
    queryLastNLogs({ variables: { n } });
  };
}

export function QueryLogsByDateRange() {
  const dispatch = useDispatch();
  const [queryLogsByDateRange, { data, loading, error }] = useLazyQuery(
    QUERY_LOGS_BY_DATE_RANGE,
  );
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setLogs(data.getLogsByDateRange));
    }
  }, [dispatch, data, loading, error]);
  return (startDate: number, endDate: number) => {
    queryLogsByDateRange({ variables: { startDate, endDate } });
  };
}

export function QueryConnectedServices() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_CONNECTED_SERVICES);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setConnectedServices(data.getConnectedServices));
    }
  }, [dispatch, data, loading, error]);
}

export function QueryServerTime() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_SERVER_TIME);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setServerTime(data.getServerTime));
    }
  }, [dispatch, data, loading, error]);
}

export function SubscribeHeartbeat() {
  const { error } = useSubscription(SUBSCRIBE_HEARTBEAT, {});
  if (error) {
    console.log(error);
  }
}

export function SubscribeNewServerTimeUpdate() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_NEW_SERVER_TIME_UPDATE, {
    onData: (x) => {
      const newServerTime = x.data.data.newServerTimeUpdate;
      dispatch(setServerTime(newServerTime));
    },
  });
  if (error) {
    console.log(error);
  }
}

export function SubscribeNewLogUpdate() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_NEW_LOG_UPDATE, {
    onData: (x) => {
      const newLog = x.data.data.newLogUpdate;
      dispatch(addLog(newLog));
    },
  });
  if (error) {
    console.log(error);
  }
}

export function SubscribeUserViewingPageUpdate() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_NEW_USER_VIEWING_PAGE_UPDATE, {
    onData: (x) => {
      const userViewingPageUpdate = x.data.data.newUserViewingPageUpdate;
      dispatch(setUserViewingPageUpdate(userViewingPageUpdate));
    },
  });
  if (error) {
    console.log(error);
  }
}

export function SubscribeConnectedServiceUpdate() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_NEW_CONNECTED_SERVICE_UPDATE, {
    onData: (x) => {
      const connectedServiceUpdate = x.data.data.newConnectedServiceUpdate;
      dispatch(setConnectedServiceUpdate(connectedServiceUpdate));
    },
  });
  if (error) {
    console.log(error);
  }
}

let ressettingFrontend = false;
export function SubscribeResetFrontend() {
  const dispatch = useDispatch();
  const client = useApolloClient();
  const { error } = useSubscription(SUBSCRIBE_RESET_FRONTEND, {
    onData: async (_) => {
      if (!ressettingFrontend) {
        ressettingFrontend = true;
        try {
          toast("AKS Dashboard reset", { icon: "🔄" });
          dispatch(resetApp());
          dispatch(setWsConnectedState(true));
          await client.resetStore();
        } finally {
          ressettingFrontend = false;
        }
      }
    },
  });
  if (error) {
    console.log(error);
  }
}
